const styles = {
    main: {
        width: '100%',
        minHeight: '500px',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
    },
    super: {
        width: '1000px',
        '@media (max-width: 600px)': {
            width: '100%',
        },
    },
    dream: {
        width: '1000px',
        '@media (max-width: 600px)': {
            width: '100%',
        },
    },
    gold: {
        '@media (max-width: 600px)': {
            backgroundColor: '#EAD19D',
        },
    },
    quickLinks: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: '20px 0',
        '@media (max-width: 600px)': {
            width: '100%',
            height: '100%',
            margin: '0 0 20px 0',
        },
    },
    optional: {
        width: '500px',
        fontSize: '0.85rem',
        marginBottom: '20px',
        '@media (max-width: 600px)': {
            width: '95%'
        },
    },
    purchase: {
        width: '400px',
        fontSize: '0.85rem',
        marginBottom: '20px',
        '@media (max-width: 600px)': {
            width: '90%'
        },
    },
    copy: {
        width: '500px',
        fontSize: '0.85rem',
        marginBottom: '50px',
        '@media (max-width: 600px)': {
            width: '90%'
        },
    },
    brand: {
        width: 'auto',
        maxHeight: '50px'
    },
    brandContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px'
    }
};

export default styles;